export const sponsorshipKeys = {
  all: ["sponsorships"],
  lists: () => [...sponsorshipKeys.all, "list"],
  // filters object makes the key unique per filter combination.
  // Invalidating sponsorshipKeys.lists() clears ALL list variants.
  list: (filters = {}) => [...sponsorshipKeys.lists(), filters],
  details: () => [...sponsorshipKeys.all, "detail"],
  detail: (id) => [...sponsorshipKeys.details(), id],
};
